import React, { FC } from 'react';
import styled, { css } from 'styled-components';

import Text from '@/components/Text';

const Box = styled.button`
  user-select: none;
  display: flex;
  padding: 4px;
  padding-left: 12px;
  border-radius: 4px;
  gap: 8px;
  border: solid 1px ${({ theme }) => theme.colors.lightGray};
  align-items: center;
  transition: border-color ease-out 0.2s;
  background-color: ${({ theme }) => theme.colors.white};
  &:hover {
    border-color: rgba(34, 34, 34, 0.25);
  }
`;

interface SwitchesProps {
  $active?: boolean;
}

const Switches = styled.div<SwitchesProps>`
  display: flex;
  position: relative;
  gap: 4px;
  &:after {
    content: '';
    width: 58px;
    height: 22px;
    border-radius: 4px;
    position: absolute;
    left: 0;
    top: 0;
    transition: all ease-out 0.2s;
    background-color: ${({ theme }) => theme.colors.purple};
  }
  ${({ $active }) =>
    $active &&
    css`
      color: ${({ theme }) => theme.colors.white};
      &:after {
        left: 62px;
      }
    `}
`;

const Switch = styled(Text)<{ $active?: boolean }>`
  width: 58px;
  height: 22px;
  justify-content: center;
  align-items: center;
  display: flex;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.gray};
  position: relative;
  transition: color ease-out 0.2s;
  span {
    position: relative;
    z-index: 1;
  }
  ${({ $active }) =>
    $active &&
    css`
      color: ${({ theme }) => theme.colors.white};
    `}
`;

interface Props {
  isDrafts: boolean;
  onClick: () => void;
}

const PostStatusFilter: FC<Props> = ({ isDrafts, onClick }) => {
  return (
    <Box onClick={onClick} type="button">
      <Text $type="smallHeadline">Post Status:</Text>
      <Switches $active={isDrafts}>
        <Switch $active={!isDrafts} $type="small">
          <span>Published</span>
        </Switch>
        <Switch $active={isDrafts} $type="small">
          <span>Drafts</span>
        </Switch>
      </Switches>
    </Box>
  );
};

export default PostStatusFilter;
